import { BaseModel } from '@/shared/types/base.model';

export class BookingExportFilter {
  constructor(
    public from: Date = new Date(),
    public to: Date = new Date(),
    public projects?: string[],
  ) {}
}
